const LANES = [
  { lane: 'Rotterdam → Warsaw', trips: 18, margin: 24.1 },
  { lane: 'Hamburg → Madrid', trips: 14, margin: 19.4 },
  { lane: 'Antwerp → Milan', trips: 11, margin: 17.8 },
  { lane: 'Lyon → Bucharest', trips: 9, margin: 16.2 },
  { lane: 'Gdansk → Lisbon', trips: 6, margin: 12.9 },
]

const maxMargin = Math.max(...LANES.map((l) => l.margin))

export function LaneTable() {
  return (
    <ul className="space-y-3">
      {LANES.map((l) => {
        const pct = (l.margin / maxMargin) * 100
        return (
          <li key={l.lane}>
            <div className="flex items-baseline justify-between gap-3 mb-1.5">
              <span className="text-[12.5px] font-medium truncate">{l.lane}</span>
              <span className="tnum text-[12px] text-positive font-semibold shrink-0">
                {l.margin.toFixed(1)}%
              </span>
            </div>
            <div className="h-1.5 rounded-full bg-border overflow-hidden">
              <div
                className="h-full bg-primary"
                style={{ width: `${pct}%` }}
              />
            </div>
            <p className="mt-1.5 text-[10.5px] text-muted-foreground tnum">
              {l.trips} sapar
            </p>
          </li>
        )
      })}
    </ul>
  )
}
